import { AsYouType } from 'libphonenumber-js'

export const formatPhone = (number, prefix=false) => {
    if (number) {
        let formated = new AsYouType().input(number)
        if (!prefix) formated = formated.replace(`+33 `, '0')
        return formated
    }
    return null
}
